import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try {
      const raw = localStorage.getItem('trackr_profile');
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  });

  const saveUser = (profile) => {
    localStorage.setItem('trackr_profile', JSON.stringify(profile));
    setUser(profile);
  };

  const logout = () => {
    localStorage.removeItem('trackr_profile');
    localStorage.removeItem('trackr_goals');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser: saveUser, loading: false, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be inside AuthProvider');
  return ctx;
};

export const wUnit = (profile) => (profile?.units === 'metric' ? 'kg' : 'lb');
export const hUnit = (profile) => (profile?.units === 'metric' ? 'cm' : 'ft/in');
